import SearchBar from './SearchBar';

export default function HeroBanner({ onSearch }) {
  return (
    <div className="relative w-full overflow-hidden">
      {/* Hero Background Image */}
      <div
        className="w-full min-h-[500px] md:min-h-[600px] lg:min-h-[700px] bg-cover bg-center bg-no-repeat flex items-center justify-center"
        style={{
          backgroundImage: 'url(/images/hero-banner.jpg)',
        }}
      >
        {/* Dark overlay for better text contrast (optional, very subtle) */}
        <div className="absolute inset-0 bg-black/5"></div>

        {/* Content Overlay */}
        <div className="relative z-10 w-full container mx-auto px-4 flex items-center justify-center">
          <div className="w-full max-w-2xl">
            {/* Search Bar with White Background for Contrast */}
            <div className="bg-white/95 backdrop-blur-sm rounded-xl shadow-2xl p-8">
              <SearchBar onSearch={onSearch} />
            </div>

            {/* Tagline Below Search */}
            <div className="text-center mt-6">
              <p className="text-sm md:text-base text-slate-600 font-medium">
                Searching across Tom's Hardware, Wirecutter, CNET, The Verge, PCMag, and more...
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
